import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function MobileTrialBar() {
  return (
    <div className="md:hidden fixed bottom-0 inset-x-0 z-40 border-t border-[#E8ECF2] bg-white/92 backdrop-blur px-4 py-2 pb-[max(0.5rem,env(safe-area-inset-bottom))]" data-testid="mobile-trial-bar">
      <Link to="/register" data-testid="mobile-trial-bar-cta"
        className="flex items-center justify-between rounded-full bg-[#2C6BAC] px-5 h-11 text-sm font-semibold text-white hover:bg-[#1A3A5C] transition-colors">
        <span>Start Free Trial</span>
        <span className="inline-flex items-center gap-2 text-xs font-normal text-[#E8ECF2]/90">14 days, no card <ArrowRight size={14} /></span>
      </Link>
    </div>
  );
}
